import { STATUS } from "../theme/tokens";

export const errorOutlineSx = {
	"& .MuiOutlinedInput-notchedOutline": { borderColor: `${STATUS.ERROR.main} !important` },
	"&:hover .MuiOutlinedInput-notchedOutline": { borderColor: `${STATUS.ERROR.main} !important` },
	"&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: `${STATUS.ERROR.main} !important` },
};
